import { FormBuilder, FormGroup } from '@angular/forms';
import { FormatValidationService } from '@xpo-ltl/common-services';
import { EmailEntryFormBuilder } from '../../../../../../lib/src/lib/notes-emails/public_api';
import { AmendEmailDialogFormNamesEnum } from '../../../../enums/form-control-names/amend-email-dialog-form-names.enum';

export class AmendEmailDialogFormBuilder {
  static create(fb: FormBuilder, formatValidationService: FormatValidationService): FormGroup {
    return fb.group({
      [AmendEmailDialogFormNamesEnum.EMAIL]: EmailEntryFormBuilder.create(fb, formatValidationService),
    });
  }
}
